import CarouselNavButtonItem from './CarouselNavButtonItem';
import { CarouselNavButtonVariant } from './carousel-nav-buttons-props.interface';
import classNames from 'classnames';
import React from 'react';

interface CarouselSideButtonsProps {
  onPrev: () => void;
  onNext: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  prevAriaLabel?: string;
  nextAriaLabel?: string;
  className?: string;
  variant?: CarouselNavButtonVariant;
}

const CarouselSideButtons: React.FC<CarouselSideButtonsProps> = ({
  onPrev,
  onNext,
  isPrevDisabled = false,
  isNextDisabled = false,
  prevAriaLabel = 'Previous',
  nextAriaLabel = 'Next',
  className = 'left-0 right-0',
  variant = 'floating',
}) => (
  <div
    className={classNames(
      'pointer-events-none absolute top-1/2 z-20 hidden -translate-y-1/2 items-center justify-between md:flex',
      className
    )}
  >
    <CarouselNavButtonItem
      direction="left"
      disabled={isPrevDisabled}
      ariaLabel={prevAriaLabel}
      onClick={onPrev}
      variant={variant}
      className="pointer-events-auto"
    />
    <CarouselNavButtonItem
      direction="right"
      disabled={isNextDisabled}
      ariaLabel={nextAriaLabel}
      onClick={onNext}
      variant={variant}
      className="pointer-events-auto"
    />
  </div>
);

export default CarouselSideButtons;
